<template>
    <div :class="['profile', theme]">
        <span class="icon-user profile__user-icon"></span>
        <span class="profile__link-label" @click="toggleLogin">
            <span class="profile__user-name">{{ getUserName }}</span>
            <span class="profile__icon icon-chevron-down"></span>
        </span>
        <div class="profile__profile-box" v-show="isLoginBoxOpen">
            <router-link v-for="userMenuItem in userMenuForDropdown" :key="userMenuItem.title" class="profile__link"
                         :to="{ name: userMenuItem.href.name }">
                <span
                    class="profile__user-option"
                    @click="toggleLogin"
                >
                {{ userMenuItem.title }}
                </span>
            </router-link>
            <template v-if="adminToolsForDropdown.length > 0 || userManagementEnabled">
                <div class="profile__user-option-separator"></div>
                <span class="profile__user-option-subtitle" v-html="$t('StoreMenu.admin_tools')"></span>
                <div v-for="adminToolItem in adminToolsForDropdown" :key="adminToolItem.title">
                    <div class="profile__user-option" v-on:click="goToKnowledgeCenter"
                         v-if="adminToolItem.attributes.id === 'knowledge-center'">
                        {{ adminToolItem.title }}
                        <span class="icon-launch profile__icon"></span>
                    </div>
                    <router-link class="profile__link" :to="{ name: adminToolItem.href.name }" v-if="adminToolItem.attributes.id === 'organization-report'">
                        <span
                            class="profile__user-option"
                            @click="toggleLogin"
                        >
                            {{ adminToolItem.title }}
                        </span>
                    </router-link>
                    <div class="profile__user-option" v-on:click="goToUserManagement"  v-if="adminToolItem.attributes.id === 'user-management'">
                        {{ adminToolItem.title }}
                        <span class="icon-launch profile__icon"></span>
                    </div>
                </div>
            </template>
            <div class="profile__user-option" v-on:click="goToUserManagement" v-if="userManagementEnabled">
                {{ $t('StoreMenu.user_management') }}
                <span class="icon-launch profile__icon"></span>
            </div>
            <div class="profile__user-option-separator"></div>
            <div class="profile__user-option" v-on:click="logout">
                {{ $t('Menu.log_out') }}
                <span class="icon-exit profile__logout-icon"></span>
            </div>
        </div>
    </div>
</template>

<script>
    import LoginFormHelper from 'components/shared/mixins/loginFormHelper'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [LoginFormHelper],
        inject: ['headerTheme'],
        computed: {
            ...mapGetters({
                currentUserInfo: 'User/getCurrentUser',
                userInfo: 'User/getUserInfo',
                userMenu: 'Menu/getUserMenu',
                isLoginBoxOpen: 'User/getIsLoginBoxOpen'
            }),
            getUserName () {
                if (!this.currentUserInfo?.firstName) {
                    return ''
                }
                return this.currentUserInfo.firstName + ' ' + this.currentUserInfo.lastName
            },
            theme () {
                return this.headerTheme()
            },
            userMenuForDropdown () {
                return this.userMenu.filter((el, index) => el.attributes.section !== 'adminTools' && index < this.userMenu.length - 1)
            },
            adminToolsForDropdown () {
                return this.userMenu.filter(el => el.attributes.section === 'adminTools')
            },
            userManagementEnabled () {
                const permissions = this.userInfo?.rolesWithPermissions || []
                return !!permissions.length && permissions.find(permission => permission.role === 'organization_main_user' && permission?.permissions?.length)
            }
        }
    }
</script>

<style lang="scss" scoped>
.profile {
    &.dark {
        color: $black;
    }

    &__link-label {
        cursor: pointer;
        font-family: Nunito-Bold, sans-serif;
    }

    &__user-name {
        display: none;
        font-family: PlusJakartaSans-Medium, sans-serif;
        [class*="desktop_xx"] & {
            display: inline-block;
        }
    }

    &__user-option {
        font-family: PlusJakartaSans-Regular, sans-serif;
        padding: 12px 20px;
        font-size: 1.6rem;
        color: $tuatara;
        align-items: center;
        display: flex;

        &:hover {
            a {
                cursor: pointer;
            }

            cursor: pointer;
            background: $wild_sand;
        }
    }

    &__user-icon {
        border-radius: 20px;
        padding: 4px 7px;
        margin: 0 3px 0 0;
    }

    &__icon {
        margin: 0 0 0 10px;
        font-size: 1.5rem;
    }

    &__logout-icon {
        margin-left: auto;
    }

    &__user-option-separator {
        border-top: 1px solid $alto;
        width: 100%;
    }

    &__user-option-subtitle {
        font-family: PlusJakartaSans-Regular, sans-serif;
        font-size: 1.2rem;
        color: $tuatara;
        text-transform: uppercase;
        padding: 10px 20px 0 20px;
        display: inline-block;
    }

    &__profile-box {
        top: 50px;
        right: 0;
        position: absolute;
        border: solid $alto 1px;
        background: $white;
        z-index: 1000;
        transition: all 0.1s ease-in-out 0s, visibility 0s linear 0.1s, z-index 0s linear 0.01s;
        width: 280px;
        text-align: left;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);
    }
}
</style>
